import React, { useState, useEffect } from "react";
import axios from "axios";
import Meta from "../components/Meta";
import MessengerCustomerChat from 'react-messenger-customer-chat';
// import Loader from "../components/Loader";
// import Paginate from "../components/Paginate";
// import { config } from "../utils/tokenConfig";
// import { LinkContainer } from "react-router-bootstrap";
// import { Button, Form } from "react-bootstrap";
// import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


export default function AllUsersScreen({ location, history }) {
  const [loading, setLoading] = useState(true);
  const [pager, setPager] = useState({});
  const [pageOfItems, setPageOfItems] = useState([]);
  useEffect(() => {
    try {
      async function fetchUserData() {
        const params = new URLSearchParams(location.search);
        const page = parseInt(params.get("page")) || 1;
        setLoading(true);
        if (page !== pager.currentPage) {
          let {
            data: { pager, pageOfItems },
          } = await axios.get(`/api/forms/visa?page=${page}`);
          setPager(pager);
          setPageOfItems(pageOfItems);
          setLoading(false);
        }
      }
      fetchUserData();
    } catch (error) {
      console.log(error);
    }
  }, [location.search, pager.currentPage]);
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/vendor/bootstrap.min.css"/>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/vendor/fontawesome.all.css"/>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/vendor/owl.carousel.min.css"/>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/vendor/venobox.css"/>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/vendor/animate.css"/>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/vendor/jquery-ui.min.css"/>
        <link rel="stylesheet" href="./assets/css/style.css"/>
        <link rel="stylesheet" href="https://d2lwpwm4byf9x.cloudfront.net/assets/css/responsive.css"/>
      </Helmet>
      <Meta title={"All Visa List - Bideshi Chakri"} />
      
      {/* <div id="preloader"></div> */}
    

    <div class="main-container">
       {/* header start */}
        <header class="header-section no-printme">
       {/* <div class="slider-text">
              <h3 class="white-text">সৌদি আরবে জরুরী নিয়োগ বিজ্ঞপ্তি</h3>
       </div> */}
          <div class="slider-area owl-carousel">
            <div class="slider-wrapper">
              <div class="slider-img">
              <img src="https://d2lwpwm4byf9x.cloudfront.net/assets/images/slider/slider1.jpg" alt="" class="img-fluid"/>
              </div>
            </div>
            <div class="slider-wrapper">
              <div class="slider-img">
                <img src="https://d2lwpwm4byf9x.cloudfront.net/assets/images/slider/slider2.png" alt="" class="img-fluid"/>
              </div>
            </div>
            <div class="slider-wrapper">
              <div class="slider-img">
                <img src="https://d2lwpwm4byf9x.cloudfront.net/assets/images/slider/slider-5.png" alt="" class="img-fluid"/>
              </div>
            </div>
            <div class="slider-wrapper">
              <div class="slider-img">
                <img src="https://d2lwpwm4byf9x.cloudfront.net/assets/images/slider/slider4.png" alt="" class="img-fluid"/>
              </div>
            </div>
          </div>
        </header>
        {/* header end */}

        {/* testimonial section start */}
        <div class="testimonial-section mar50 no-printme">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12 col-lg-12">
                        <marquee class="testimonial-text" behavior="scroll" direction="right" onmouseover="this.stop();" onmouseout="this.start();">
                          <p class="bold black-text">
                            সৌদি আরবে জরুরী নিয়োগ বিজ্ঞপ্তি
                          </p>
                        </marquee>
                    </div>
                </div>
            </div>
        </div>
         {/* testimonial section end   */}

        <section class="table-class pad50">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-responsive table-box">
                            <table class="table table-bordered">
                              <thead class="thead-dark">
                                <tr>
                                  <th>Company</th>
                                  <th>Country</th>
                                  <th>Occupation</th>
                                  <th>Salary</th>
                                  <th>Food</th>
                                  <th>Requirement</th>
                                  <th style={{width:"7%"}}>Duty Hour</th>
                                  <th>Facilities</th>
                                  <th>Remark</th>
                                  <th>Reference</th>
                                </tr>
                              </thead>
                              <tbody>
                              {pageOfItems.map((visa) => (
                                <tr key={visa._id}>
                                  <td>{visa.company}</td>
                                  <td>{visa.country}</td>
                                  <td>{visa.occupation}</td>
                                  <td>{visa.salary}</td>
                                  <td>{visa.food}</td>
                                  <td>{visa.requirement}</td>
                                  <td>{visa.dutyhour}</td>
                                  <td>{visa.facilities}</td>
                                  <td>{visa.remark}</td>
                                  <td>{visa.reference}</td>
                                </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                    </div>
                    <div class="col-lg-12 no-printme">
                        <div class="table-button">
                            <button class="btn table-btn" onClick={()=>window.print()}>Print</button>
                        </div>
                        <br/>
                        <div class="table-button">
                        <a href="#">
                        <img style={{width:170}} src="https://d2lwpwm4byf9x.cloudfront.net/assets/images/slider/google-play.png" alt=""/> 
                        </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        {/* footer-section start */}
        <footer class="footer-section pad20">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="footer-content">
                            <div class="footer-logo-content"><h4 class="bold">মেসার্স আই ট্রেড<span>আর এল-৪৮৫</span></h4></div>
                            <div class="ftr-address mt8"><p class="semi-bold">বাড়ি # ০৯, রোড # ২৭, ব্লক- কে বনানী, ঢাকা-১২১৩</p></div>
                            <div class="ftr-contact mt8"><p class="semi-bold">ফোনঃ ৮৮-০২-৫৮৮১৭৩৮৪, ৯৮৮১১২০  ই-মেইলঃ <span>itradegbb@gmail.com</span></p></div>
                            <div class="ftr-mobile mt8"><h5 class="bold">মোবাইলঃ <span>+ 8801300-480413</span></h5></div>
                            <ul class="footer-social mt8">
                                <li><a href="#"><i class="twitter fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="youtube fab fa-youtube"></i></a></li>
                                <li><a href="https://www.facebook.com/idolgroup.com.bd"><i class="facebook fab fa-facebook"></i></a></li>
                                <li><a href="#"><i class="instagram fab fa-instagram-square"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        {/* footer-section end */}
        <MessengerCustomerChat
      pageId="315587155783903"
      appId="466001461592196"
     
    />
    </div>
    {/* back to to btn start */}
    <div class="no-printme" id="back-to-top"></div>

    <Helmet>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/jquery-3.2.1.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/jquery-migrate.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/jquery-ui.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/bootstrap.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/popper-1.12.3.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/venobox.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/owl.carousel.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/vendor/wow.min.js"></script>
        <script type="text/javascript" src="https://d2lwpwm4byf9x.cloudfront.net/assets/js/main.js"></script>
       
    </Helmet>
    </>
  );
}
